import axios from "axios";

let pbApiUrlBase = 'https://api.kanalk.ch/v2/pluxbox/';
// let pbApiUrlBase = 'https://meta.kanalk.ch/api/apikanalkchtemp/pluxbox/'

/**
 * Show Description via Show ID
 * @param pbShowId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function pbFetchShowDescription(pbShowId) {
    return axios
        .get(pbApiUrlBase + 'broadcastDetails?broadcast=' + pbShowId)
        .then(res => {
            if (typeof res.data.description !== "undefined") {
                return res.data.description
            }
            return false;
        });
}



/**
 * Current Program
 * @returns {Promise<AxiosResponse<any>>}
 */
export function pbFetchProgramCurrent() {
    return axios
        .get(pbApiUrlBase + 'programCurrent')
        .then(res => {
            if (typeof res.data !== "undefined") {
                return res.data
            }
            return false;
        });
}

/**
 * Next Program
 * @returns {Promise<AxiosResponse<any>>}
 */
export function pbFetchProgramNext() {
    return axios
        .get(pbApiUrlBase + 'programNext')
        .then(res => {
            if (typeof res.data !== "undefined") {
                return res.data
            }
            return false;
        });
}

/**
 * Todays Program Full
 * @returns {Promise<AxiosResponse<any>>}
 */
export function pbFetchProgramToday() {
    return axios
        .get(pbApiUrlBase + 'programToday&days=0')
        .then(res => {
            if (typeof res.data !== "undefined") {
                return res.data
            }
            return false;
        });
}
